import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit { 
  loading : boolean;
  loggedIn : boolean = false;
  specialPages : string[]  = ['/reset/password']; 
  constructor(
    private authService: AuthenticationService 
  ) {
      
  }
  ngOnInit(){
    // console.log('init');
    this.authService.loggedIn$.subscribe(loggedIn => setTimeout(() => {console.log('called >>>'+loggedIn); this.loggedIn = loggedIn, 0}));
  }
  ngAfterViewInit(){
    // this.userService.getLoading().subscribe(loading => { this.loading = loading; });;
    this.authService.loading$.subscribe(loading => setTimeout(() => this.loading = loading, 0));
  }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/containers/full-layout/full-layout.component.ts